// const io = require("socket.io-client")
const { Manager } = require("socket.io-client")
const { listeners } = require("../store")
const helpers = require("./helpers")

module.exports = {
  ...helpers,
  connect(token) {
    return new Promise((resolve, reject) => {
      try {
        let { simtopy } = global.store.getState();
        /** @type {Manager} */
        let socketManager = globalThis.socketManager;
        if (!socketManager) {
          socketManager = new Manager(`${simtopy.protocol}//${simtopy.host}`, {
            // automatic reconnection (except for socket.disconnect() method)
            reconnection: true,
            // initial delay before reconnection
            reconnectionDelay: 150,
            // maximum reconnection delay (reconnectionDelay x2 on each attempt)
            reconnectionDelayMax: 5000,
            // timeout for each connection attempt
            timeout: 30_000,
            // no "disconnect" event
            closeOnBeforeunload: true,
          })
          globalThis.socketManager = socketManager
        }
        if (token) {
          const socket = socketManager.socket("/clients", {
            auth: { token }
          })
          socket.request = helpers.request.bind(socket);
          socket.call = helpers.call.bind(socket);
          global.socket = socket;

          console.debug("socket waiting...");

          let reconInterval, reconTimeout, disconnectedAt, connectedAt;

          socket.on("connect", () => {
            clearTimeout(reconTimeout)
            clearInterval(reconInterval)
            connectedAt = Date.now()
            if (disconnectedAt) {
              console.debug("socket recovered in", connectedAt - disconnectedAt, "ms");
            } else {
              console.debug("socket connected, waiting authorization");
            }
          });

          socket.on("authorized", ({ auth, state }) => {
            console.log("========== Connected to simtopy ==========");

            global.store.dispatch({
              type: "SOCKET_CONNECTION",
              socket,
              auth,
              disconnectedAt,
              connectedAt
            });
            if (globalThis.simtopyListener) globalThis.simtopyListener.start(state)
            else globalThis.simtopyListener = listeners.simtopy(socket, global.store, state);

            if (!disconnectedAt) resolve(globalThis.simtopyListener);
          });

          socket.on("unauthorized", err => {
            console.debug("socket unauthorized", err);
            global.store.dispatch({
              type: "SOCKET_UNAUTHORIZED"
            })
            socket.close()
            reject(err);
          });

          socket.io.on("reconnect", (attempt) => {
            console.debug("socket reconnected, attempt:", attempt);
          });

          socket.io.on("reconnect_attempt", (attempt) => {
            console.debug("socket reconnect_attempt", attempt);
          });

          const onDisconnect = eventName => (...args) => {
            console.debug("socket", eventName, ...args.filter(e => e !== undefined));
            global.store.dispatch({
              type: "SOCKET_DISCONNECTED",
              connectedAt,
              disconnectedAt
            })
          }

          socket.io.on("reconnect_error", onDisconnect("reconnect_error"));
          socket.io.on("reconnect_failed", onDisconnect("reconnect_failed"));

          const handleError = eventName => err => {
            console.debug("socket", eventName, err);
            console.error("socket", eventName, err);
            if (!socket.active) {
              global.store.dispatch({
                type: "SOCKET_ERROR",
                error: err,
                disconnectedAt,
                connectedAt
              })
            }
            if (!connectedAt) reject(err);
          }

          socket.on("connect_error", handleError("connect_error"));
          socket.io.on("error", handleError("error"));

          socket.on("disconnect", (reason, details) => {
            console.debug("socket disconnected", reason, details);

            disconnectedAt = Date.now()
            onDisconnect("disconnect")(reason, details)

            if (!socket.active) {
              console.error("disconnected", reason, details);

              reconTimeout = setTimeout(() => {
                clearInterval(reconInterval)
                // if (!socket.connected) {
                //   onDisconnect("disconnect")(reason, details)
                // }
              }, 5_000)

              if (process.env.NODE_ENV !== "development") {
                let attempt = 0
                reconInterval = setInterval(() => {
                  if (!socket.connected) {
                    console.debug("socket reconnection attempt", attempt++);
                    socket.connect()
                  }
                }, 200)
              }
            } else {
              console.debug("socket automatic reconnection...");
            }
          });

        } else reject("no user token found (user disconnected)");
      } catch (err) {
        console.error(err);
        reject(err);
      }
    });
  },

  socketCall({
    action,
    params,
    ...options
  }) {
    if (global.socket) {
      return global.socket.call({
        action,
        params,
        ...options
      }).catch(err => {
        console.error(`Error calling admin.${action} with params:`, params);
        console.error(err)
        throw err
      });
    } else return Promise.reject("socket is null");
  }
}
